export function submitKlaviyoSubscription(payload) {
  return {
    type: 'SUBMIT_KLAVIYO_SUBSCRIPTION',
    payload,
  };
}
